import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-ph-collapse',
  templateUrl: './ph-collapse.component.html',
  styleUrls: ['./ph-collapse.component.scss'],
})
export class PhCollapseComponent implements OnInit {
  @ViewChild('phCollapse', { static: true }) elDom: ElementRef;
  @Input() open: boolean = false;
  @Input() title: string;
  @Input() openOnDesktop: boolean = true;
  @Input() info: string;
  @Input() section_info: string;
  @Input() anchor: string = null;
  @Input() section: string = null;
  @Input() htmlContent: string = null;
  opened: boolean = false;
  statusWorkTimer: any = null;

  constructor() {}

  ngOnInit() {
    // if props[open] === (true) -> open this collapse
    if (this.open) {
      // wait for render all elements
      setTimeout(() => {
        this.reopen();
        this.changeSize();
      });
    }
  }

  public openMethodCollapse() {
    this.reopen();
    this.changeSize();
  }

  focusElTab(event) {
    // if you 'keyUp' with help 'Tab' (jump on next input)
    // open this collapse, if he not open
    if (!this.open) {
      this.open = true;
      this.changeSize();
    }
  }

  toggleCollapse() {
    // you can open collapse 1 time in 300ms
    if (this.statusWorkTimer !== null) {
      clearTimeout(this.statusWorkTimer);
    }
    this.statusWorkTimer = setTimeout(() => {
      this.open = !this.open;
      this.changeSize();
    }, 300);
  }

  changeSize() {
    if (this.opened) {
      this.closeBox();
    } else {
      this.openBox();
    }
  }

  reopen() {
    window.addEventListener('resize', () => {
      if (window.innerWidth > 767 && this.openOnDesktop) {
        this.open = true;
        this.openBox();
      }
    });
  }

  closeBox() {
    this.opened = false;
    setTimeout(() => {
      this.elDom.nativeElement.style.height = 72 + 'px';
    }, 10);
  }

  openBox() {
    this.elDom.nativeElement.style.height = this.elDom.nativeElement.scrollHeight + 'px';
    setTimeout(() => {
      this.opened = true;
    }, 300);
  }
}
